<dv-grid [actions]="actions()">
  <ag-grid-angular
    dvGridInSidesheet
    dvPinSelectedRow
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    [customColumnState]="customColumnState"
    (selectionChanged)="onSelectionChanged($event)"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</dv-grid>
